/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCartsPageSummaryFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type CartsPageSummary, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/carts/summary
 */
export interface SummaryRequestBuilder extends BaseRequestBuilder<SummaryRequestBuilder> {
    /**
     * The figures in the metric row above the cart list, over carts that belong to a customer (a rep's anonymous scratch cart is left out): how many are open and their value, by age (under 7 days, 7 to 14, over 14), the value of those over 14 days old, and cart-to-order conversion over the last 30 days — carts checked out divided by carts checked out plus carts opened in that time and still open. A checked-out cart is removed and a discarded one leaves no record, so this is the share of the month's carts still accounted for that became orders. conversionGoal is the goal it is measured against. Figures may be up to a few minutes old.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CartsPageSummary>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CartsPageSummary | undefined>;
    /**
     * The figures in the metric row above the cart list, over carts that belong to a customer (a rep's anonymous scratch cart is left out): how many are open and their value, by age (under 7 days, 7 to 14, over 14), the value of those over 14 days old, and cart-to-order conversion over the last 30 days — carts checked out divided by carts checked out plus carts opened in that time and still open. A checked-out cart is removed and a discarded one leaves no record, so this is the share of the month's carts still accounted for that became orders. conversionGoal is the goal it is measured against. Figures may be up to a few minutes old.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const SummaryRequestBuilderUriTemplate = "{+baseurl}/api/analytics/carts/summary";
/**
 * Metadata for all the requests in the request builder.
 */
export const SummaryRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: SummaryRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCartsPageSummaryFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
